const validator = {
  /**
   * Valida se um valor é do tipo Telefone ou Celular
   * @param  {String} value [description]
   * @param  {Object} args  [description]
   * @return {Boolean}      Retorna se o campo é valido
   */
  validate (value, args) {
    const fixo = /^(?:(55\d{2})|\d{2})[2-6]\d{7}$/
    const celular = /^(?:(55\d{2})|\d{2})[6-9]\d{8}$/
    return fixo.test(value) || celular.test(value)
  }
}

export default validator
